var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneDollar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 118,
    height: 118,
    rx: 31,
    stroke: "#09547E",
    strokeOpacity: 0.05,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4567 83.5573H55.9937V85.5707H65.4567V83.5573Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3921 37.9813L63.3916 35.9679L58.0627 35.9691L58.0632 37.9825L63.3921 37.9813Z",
    fill: "#E0E0E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7317 68.2549H59.7183V71.6374H61.7317V68.2549Z",
    fill: "#2DCDAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7317 45.678H59.7183V48.9733H61.7317V45.678Z",
    fill: "#2DCDAF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4633 69.2617H58.9868C55.8929 69.2617 53.3694 66.8188 53.3694 63.8121H55.3828C55.3828 65.7114 57.0002 67.2483 58.9868 67.2483H62.4633C64.6647 67.2483 66.4566 65.5369 66.4566 63.4295C66.4566 62.4161 66.0472 61.4631 65.3023 60.7449C64.5439 60.0134 63.5372 59.6174 62.47 59.6174H58.9935C55.6848 59.6174 52.9868 57 52.9868 53.7919C52.9868 52.2282 53.6177 50.7584 54.7586 49.6577C55.8929 48.5637 57.3962 47.9597 58.9935 47.9597H62.47C65.564 47.9597 68.0875 50.4027 68.0875 53.4094H66.0741C66.0741 51.5101 64.4566 49.9731 62.47 49.9731H58.9935C57.9197 49.9731 56.913 50.3758 56.1613 51.1007C55.4163 51.8188 55.0069 52.7718 55.0069 53.7852C55.0069 55.8859 56.7989 57.5973 59.0002 57.5973H62.4767C64.0741 57.5973 65.5774 58.2013 66.7116 59.2953C67.8526 60.396 68.4835 61.8658 68.4835 63.4295C68.47 66.651 65.7721 69.2617 62.4633 69.2617Z",
    fill: "#2DCDAF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4493 79.1881H43.0063V81.2015H78.4493V79.1881Z",
    fill: "#00A3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7651 90H44.6846C43.2013 90 42 88.7987 42 87.3154V32.6846C42 31.2013 43.2013 30 44.6846 30H76.7651C78.2483 30 79.4497 31.2013 79.4497 32.6846V87.3154C79.4497 88.7987 78.2483 90 76.7651 90ZM44.6846 32.0134C44.3154 32.0134 44.0134 32.3154 44.0134 32.6846V87.3154C44.0134 87.6846 44.3154 87.9866 44.6846 87.9866H76.7651C77.1342 87.9866 77.4362 87.6846 77.4362 87.3154V32.6846C77.4362 32.3154 77.1342 32.0134 76.7651 32.0134H44.6846Z",
    fill: "#00A3FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneDollar);
export default __webpack_public_path__ + "static/media/phoneDollar.8a59a298711ebd373049666a482cdcab.svg";
export { ForwardRef as ReactComponent };